export const DELETE_ORGANIZATION_MODAL_NAME = 'DELETE_ORGANIZATION_MODAL_NAME';
